module.exports = __webpack_public_path__ + "static/media/msg-vehicle.94d30ed8.svg";